const config = {
  REACT_APP_API_URL: window.location.origin + '/'
};

export default config;
